/**
 * «Заявки на выдачу» is the station's worklist; «Ожидают подтверждения» is the
 * inbox of batches issued *to* the caller's organization — the same endpoints
 * serve a receiving institution and a receiving blood centre.
 */
export const ISSUANCE_TABS = ['applications', 'receipts'] as const

export type TIssuanceTab = (typeof ISSUANCE_TABS)[number]
